"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarsAndSold = void 0;
var React = require("react");
var StarIcon_1 = require("../../../../../../components/newLTUI/StarIcon");
var styles_1 = require("./styles");
exports.StarsAndSold = function (props) {
    var star = props.star, sold = props.sold;
    return (React.createElement(styles_1.StarsAndSoldBox, null,
        !!star && (React.createElement(styles_1.LeftStar, null,
            new Array(Math.ceil(star)).fill("").map(function (_, index) {
                return React.createElement(StarIcon_1.StarIcon, { key: index, size: "12px" });
            }),
            React.createElement(styles_1.LeftStarNum, null, "" + Math.ceil(star).toFixed(1)))),
        React.createElement(styles_1.RightSold, { hasStar: !!star }, sold)));
};
